import { c as _c } from "react/compiler-runtime";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ContentBlock } from "../../ui/ContentBlock";
import { SHIMMER_COLORS } from "../../../utils/const";
export const BestSellersShimmer = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="font-display mb-6 flex text-4xl leading-tight tracking-[-0.02em] uppercase md:relative md:text-5xl"><div className="top-3 -left-12 mr-2 hidden w-9 md:absolute md:mr-0 xl:block"><Skeleton height={36} width={36} baseColor={SHIMMER_COLORS.BASE} highlightColor={SHIMMER_COLORS.HIGHLIGHT} /></div><Skeleton height={48} width={300} baseColor={SHIMMER_COLORS.BASE} highlightColor={SHIMMER_COLORS.HIGHLIGHT} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><Skeleton height={500} baseColor={SHIMMER_COLORS.BASE} highlightColor={SHIMMER_COLORS.HIGHLIGHT} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative hidden grid-cols-1 gap-8 pt-6 pb-8 md:grid md:grid-cols-2">{t1}<div className="relative grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-x-9 md:gap-y-3">{[1, 2, 3, 4].map(_temp)}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="relative grid grid-cols-1 gap-8">{[1, 2, 3].map(_temp2)}<div className="pointer-events-none absolute inset-0 z-0! bg-gradient-to-b from-transparent from-30% via-transparent to-white" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ContentBlock className="mt-6 flex max-w-6xl! flex-col justify-center py-10 lg:py-6"><div className="relative mx-6 xl:mx-0">{t0}{t2}<div className="relative pt-6 pb-16 md:hidden">{t3}<div className="absolute -mt-6 w-full"><Skeleton height={48} width="91%" baseColor={SHIMMER_COLORS.BASE} highlightColor={SHIMMER_COLORS.HIGHLIGHT} className="mx-auto rounded-md" /></div></div></div></ContentBlock>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
function _temp(i) {
  return <div key={`desktop-block-${i}`} className="w-full"><Skeleton height={200} baseColor={SHIMMER_COLORS.BASE} highlightColor={SHIMMER_COLORS.HIGHLIGHT} className="mb-1 aspect-square" /><Skeleton height={20} width="80%" baseColor={SHIMMER_COLORS.BASE} highlightColor={SHIMMER_COLORS.HIGHLIGHT} className="mb-2" /><Skeleton height={24} width={100} baseColor={SHIMMER_COLORS.BASE} highlightColor={SHIMMER_COLORS.HIGHLIGHT} /></div>;
}
function _temp2(i_0) {
  return <div key={`mobile-block-${i_0}`} className="w-full rounded-md shadow-md"><Skeleton height={200} baseColor={SHIMMER_COLORS.BASE} highlightColor={SHIMMER_COLORS.HIGHLIGHT} className="mb-1 aspect-video" /><div className="px-6 pb-4"><Skeleton height={20} width="70%" baseColor={SHIMMER_COLORS.BASE} highlightColor={SHIMMER_COLORS.HIGHLIGHT} className="mb-2" /><Skeleton height={24} width={90} baseColor={SHIMMER_COLORS.BASE} highlightColor={SHIMMER_COLORS.HIGHLIGHT} /></div></div>;
}